import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router";

import HomeNavbar from "../components/candidate/HomeNavbar";
import YourMatches from "../components/candidate/your_matches/YourMatches";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const response = await axios.get("/api/session/");
        if (!response.data.isAuthenticated) {
          navigate("/login");
        }
      } catch (error) {
        console.error("Error during check login:", error);
        navigate("/login");
      }
    };
    checkLogin();
  }, []);

  return (
    <>
      <HomeNavbar />
      <YourMatches />
    </>
  );
};

export default Home;
